import {
  authSetup,
  envSetup,
  errorSetup,
  i18nSetup,
  titleSetup,
} from './libs';

export const setupAllSteps = () => Promise.allSettled([
  authSetup(),
  envSetup(),
  errorSetup(),
  i18nSetup(),
  titleSetup()
]).then((values) => {
  const obj = {}
  values.forEach(val => {
    if (val.status === 'fulfilled') {
      Object.assign(obj, { ...val.value })
    }
  })

  return obj
})

